import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import EntryWrapper from '../../../components/EntryWrapper';
import Search from '../../../components/Search';
import PopularServices from '../../../components/PopularServices';
import SellersGallery from '../../../components/SellersGallery';
import TrustedBy from '../../../components/TrustedBy';
import Testimonials from '../../../components/Testimonials';

const LoggedOutHomepageClient: React.FC = () => {
  useImpressionManager();

  return (
    <EntryWrapper>
      <Search />
      <SellersGallery />
      <PopularServices />
      <Testimonials />
      <TrustedBy />
    </EntryWrapper>
  );
};

export default LoggedOutHomepageClient;
